export default __webpack_public_path__ + "static/media/コルン.4a44a95f.PNG";